import axios from './axios';

/**
 * Fetch user notifications.
 */
export const getNotifications = async (params = {}) => {
  return await axios.get('/api/v1/notifications', { params });
};

/**
 * Mark a single notification as read.
 */
export const markAsRead = async (id) => {
  return await axios.post(`/api/v1/notifications/${id}/read`);
};

/**
 * Mark all notifications as read.
 */
export const markAllAsRead = async () => {
  return await axios.post('/api/v1/notifications/read-all');
};

/**
 * Delete a notification.
 */
export const deleteNotification = async (id) => {
  return await axios.delete(`/api/v1/notifications/${id}`);
};

/**
 * Register device token for push notifications.
 */
export const registerDeviceToken = async (token, deviceType = 'web') => {
  return await axios.post('/api/v1/device-tokens', { token, device_type: deviceType });
};
